function getWords(str, wordLength) {
    return str
        .toLowerCase()
        .replace(/[^a-zA-Zа-яА-ЯіїґєІЇҐЄ 0-9]/g, ' ')
        .split(' ')
        .filter(function (s) { return s.length >= wordLength; });
}
function getWordsStat(arrayOfWords) {
    var result = {};
    arrayOfWords.map(function (word) {
        result[word] = !result[word] ? 1 : ++result[word];
    });
    return result;
}
export function getTextAnalysis(str, wordLength, frequency) {
    var result = {
        words: [],
        index: {}
    };
    var words = getWords(str, wordLength);
    var index = getWordsStat(words);
    Object.keys(index).map(function (word) {
        if (index[word] >= frequency) {
            result.words.push(word);
            result.index[word] = index[word];
        }
    });
    return result;
}
export function removeAllHtmlTags(str) {
    if ((str === null) || (str === ''))
        return false;
    else
        str = str.toString();
    var res = str.replace(/(<([^>]+)>)/ig, '');
    return res;
}
export function removeHtmlTags(str) {
    if (!str)
        return "";
    str = str.toString();
    str = str.replaceAll("&nbsp;", " ");
    str = str.replaceAll("<p>", "");
    str = str.replaceAll("</p>", "\n\n");
    str = str.replaceAll("<ul>", "");
    str = str.replaceAll("</ul>", "\n\n");
    str = str.replaceAll("<ol>", "");
    str = str.replaceAll("</ol>", "\n\n");
    str = str.replaceAll("<li>", "- ");
    str = str.replaceAll("</li>", "\n");
    str = str.replaceAll("<blockquote>", "");
    str = str.replaceAll("</blockquote>", "\n\n");
    str = str.replaceAll("<h1>", "");
    str = str.replaceAll("</h1>", "\n\n");
    str = str.replaceAll("<h2>", "");
    str = str.replaceAll("</h2>", "\n\n");
    str = str.replaceAll("<h3>", "");
    str = str.replaceAll("</h3>", "\n\n");
    str = str.replaceAll("<h4>", "");
    str = str.replaceAll("</h4>", "\n\n");
    str = str.replaceAll("<b>", "");
    str = str.replaceAll("</b>", "");
    str = str.replaceAll("<i>", "");
    str = str.replaceAll("</i>", "");
    return str.replace(/(<([^>]+)>)/ig, "  ");
}
